import { useRouter } from "next/router";

import { PageType } from "shared/lib/page-type";

export const useCurrentPageType = () => {
  const {
    query: { pageType },
  } = useRouter();

  if (!isPageType(pageType)) return PageType.Others;
  return pageType;
};

export function isPageType(data: unknown): data is PageType {
  return Object.values(PageType).includes(data as PageType);
}
